<template>
  <div class="form-group select2" :class="setPlaceholderClasses">
    <div class="alert alert-info" v-if="!isLoaded">
      <span>
        En attente des options
      </span>
    </div>
    <select :id="id" ref="input" v-show="isLoaded">
      <option></option>
    </select>
    <label :for="id" @click="showPicker">{{ text }}</label>
  </div>
</template>
<script>
import "@a/select2/select2.min.css";
import "@a/select2/select2-bootstrap-theme.min.css";
import "@a/select2/select2.min.js";
import placeholder from "@mixins/placeholder.js";

export default {
  name: "volcan-input-select2",
  mixins: [placeholder],
  props: {
    apiUrl: {
      type: String,
      required: true,
    },
    options: Array,
    onchange: String,
    text: String,
    allowClear: {
      type: Boolean,
      default: true,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    isParentChild: {
      type: Boolean,
      default: false,
    },
    filterData: {
      type: Function,
      default(list) {
        return list;
      },
    },
  },
  data: function () {
    return {
      id: null,
      isLoaded: false,
    };
  },
  methods: {
    showPicker() {
      $(`#${this.id}`).select2("open");
    },
    initSelect2(elem, data) {
      elem
        .select2({
          theme: "bootstrap4",
          data: data,
          multiple: this.multiple,
          templateResult: this.formatRepo,
          templateSelection: this.formatRepoSelection,
          width: "100%",
          placeholder: this.text,
          allowClear: this.allowClear,
          escapeMarkup: function (markup) {
            return markup;
          },
          language: {
            noResults: () => {
              return this.$t("noResult");
            },
          },
          matcher: (params, data) => {
            // If there are no search terms, return all of the data
            if ($.trim(params.term) === "") {
              return data;
            }

            // Do not display the item if there is no 'text' property
            if (typeof data.name === "undefined") {
              return null;
            }

            // `params.term` should be the term that is used for searching
            // `data.text` is the text that is displayed for the data object
            if (this.isParentChild) {
              if (
                data.name
                  .toLowerCase()
                  .normalize("NFD")
                  .replace(/[\u0300-\u036f]/g, "")
                  .indexOf(
                    params.term
                      .toLowerCase()
                      .normalize("NFD")
                      .replace(/[\u0300-\u036f]/g, "")
                  ) > -1 ||
                data.parentNames
                  .toLowerCase()
                  .normalize("NFD")
                  .replace(/[\u0300-\u036f]/g, "")
                  .indexOf(
                    params.term
                      .toLowerCase()
                      .normalize("NFD")
                      .replace(/[\u0300-\u036f]/g, "")
                  ) > -1
              ) {
                return $.extend({}, data, true);
              }
            } else {
              if (
                data.name
                  .toLowerCase()
                  .normalize("NFD")
                  .replace(/[\u0300-\u036f]/g, "")
                  .indexOf(
                    params.term
                      .toLowerCase()
                      .normalize("NFD")
                      .replace(/[\u0300-\u036f]/g, "")
                  ) > -1
              ) {
                return $.extend({}, data, true);
              }
            }

            // Return `null` if the term should not be displayed
            return null;
          },
        })
        .val(this.value)
        .trigger("change")
        .on("change", (e) => {
          this.$emit("input", elem.val());
        })
        .on("select2:unselecting", (e) => {
          // prevent select2 from opening when the clear buttun is clicked
          elem.data("unselecting", true);
        })
        .on("select2:open", function (e) {
          // prevent select2 from opening when the clear buttun is clicked
          if (elem.data("unselecting")) {
            elem.removeData("unselecting"); // you need to unset this before close
            elem.select2("close");
          }
        });
    },
    formatRepo(repo) {
      return this.isParentChild
        ? this.formatRepoParentChild(repo)
        : this.formatRepoNormal(repo);
    },
    formatRepoSelection(repo) {
      return repo.id === "" ? "" : repo.name;
    },
    formatRepoParentChild(repo) {
      var markup = `<div class="parent-child-name-cell">${repo.name}<div class="parent-list">${repo.parentNames}</div></div>`;

      return markup;
    },
    formatRepoNormal(repo) {
      return repo.name;
    },
  },
  created() {
    this.handCursor = true;
  },
  mounted() {
    this.id = "input" + this._uid;
    axios.get(this.apiUrl).then((response) => {
      let data = this.filterData(response.data.data);

      this.initSelect2($(this.$refs.input), data);
      this.isLoaded = true;
    });
  },
  destroyed: function () {
    $(this.$refs.input).off().select2("destroy");
  },
};
</script>
<style lang="scss">
@import "../../../Shared/Layout/Assets/sass/base/_variables.scss";

.select2-selection {
  border-radius: 2px !important;
}

.select2-container--bootstrap4.select2-container--focus .select2-selection,
.select2-container--bootstrap4.select2-container--open .select2-selection {
  border-color: $primaryColor !important;
}

.select2-container--bootstrap4 .select2-dropdown {
  border-color: $primaryColor !important;
}

.select2-container--bootstrap4 .select2-selection__clear {
  margin-right: 10px;
  padding: 10px 15px;
  top: 1px;
  position: absolute !important;
  right: 15px;
  float: none;
}

.select2-container--bootstrap4 .select2-selection__clear:hover {
  color: #fff;
  background: $secondaryColor;
}

.parent-list {
  position: absolute;
  bottom: -0.8em;
  font-size: 0.7em;
}

.parent-child-name-cell {
  position: relative;
}

.select2-selection--multiple
  .select2-selection__rendered
  .select2-selection__choice {
  margin: 10px 5px !important;
  padding: 10px !important;
}
</style>



// WEBPACK FOOTER //
// components/AdminTools/divers/input-select2.vue